import React from 'react';
import AnnualEventPage from './AnnualEventPage';

export default function AnnualEventFundraiser({caisse, context, children}) {
    const anchor = `annual-event-donation-${caisse.id}`;
    const margin = Number(caisse.marge) || 0;
    const event = {...caisse, image: caisse.bgimage, description: caisse.textContent,
        links: [{name: caisse.annualEventPage.ctaLabel, url: `#${anchor}`, kind: 'fundraising'}],
        fundraisers: caisse.withObjectif && Number(caisse.objectif) > 0 ? [{id: caisse.id, name: caisse.name,
            target: Number(caisse.objectif) + margin, received: Number.isFinite(caisse.total) ? caisse.total + margin : null,
            currency: context.org.orgDevise || context.org.devise,
        }] : [],
    };
    return <AnnualEventPage event={event} context={context}>
        <section id={anchor} style={{marginBlockStart: 24, scrollMarginBlockStart: 24}}>{children}</section>
    </AnnualEventPage>;
}
